import { markRaw } from 'vue';
import mapIcon from '@/assets/bxs-map-alt.svg';
import userIcon from '@/assets/bxs-user.svg';
import ghostIcon from '@/assets/bxs-ghost.svg';
import UserProfileCard from '@/components/user/UserProfileCard.vue';
import auditIcon from '@/assets/bxs-check-shield.svg';
import infoIcon from '@/assets/bxs-info-circle.svg';

const userProfileCard = markRaw(UserProfileCard);

const developerMenu = [
  {
    href: '/',
    component: userProfileCard,
    hiddenOnCollapse: true,
  },
  {
    title: '',
    titleKey: 'projectManagement',
    icon: {
      element: 'img',
      attributes: { src: mapIcon },
    },
    child: [
      {
        href: '/project',
        title: '',
        titleKey: 'listProject',
      },
      {
        href: '/project/new',
        title: '',
        titleKey: 'newProject',
      },
    ],
  },
  {
    title: '',
    titleKey: 'deviceManagement',
    icon: {
      element: 'img',
      attributes: { src: ghostIcon },
    },
    child: [
      {
        href: '/device',
        title: '',
        titleKey: 'listDevice',
      },
    ],
  },
  {
    title: '',
    titleKey: 'dataManagement',
    icon: {
      element: 'img',
      attributes: { src: infoIcon },
    },
    child: [
      {
        href: '/data',
        title: '',
        titleKey: 'listData',
      },
      {
        href: '/data/new',
        title: '',
        titleKey: 'newData',
      },
      {
        href: '/history',
        title: '',
        titleKey: 'listHistory',
      },
    ],
  },
  {
    title: '',
    titleKey: 'userManagement',
    icon: {
      element: 'img',
      attributes: { src: userIcon },
    },
    child: [
      {
        href: '/user',
        title: '',
        titleKey: 'listUser',
      },
      {
        href: '/user/new',
        title: '',
        titleKey: 'newUser',
      },
    ],
  },
  {
    title: '',
    titleKey: 'audit',
    href: '/audit',
    icon: {
      element: 'img',
      attributes: { src: auditIcon },
    },
  },
];

export default developerMenu;
